import React, { useState } from 'react';
import { FaEnvelope, FaGithub, FaInstagram, FaLink, FaLinkedin } from 'react-icons/fa';
import HelpModalMobile from './HelpModalMobile';
import { IoDocumentAttachOutline } from 'react-icons/io5';

const FooterMobile = () => {

  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);

  const toggleHelpModal = () => {
    setIsHelpModalVisible(!isHelpModalVisible);
  };


  return (
    <>
    <div className='absolute flex text-center flex-col flex-wrap w-full'>
        <div className="absolute top-6 p-4 rounded-lg shadow-lg text-white text-center w-full">
          <p className="font-bold text-3xl font-mono">Smit Khobragade</p>
          <p className="text-xl font-mono">Full-Stack Developer</p>
        </div>
      </div>
    <div className="absolute bottom-0 w-full">
      <div className="absolute bottom-0 w-full flex justify-between items-center bg-gray-800 p-2">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-4 gap-2">
            <a href="mailto:smitkbgd@gmail.com" target="_blank" rel="noopener noreferrer">
              <FaEnvelope className="w-6 h-6 text-white" />
            </a>
            <a href="https://github.com/Smitkhobragade" target="_blank" rel="noopener noreferrer">
              <FaGithub className="w-6 h-6 text-white" />
            </a>
            <a href="https://www.linkedin.com/in/smit-khobragade/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="w-6 h-6 text-white" />
            </a>
            <a href="https://www.instagram.com/smit_kbgd/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="w-6 h-6 text-white" />
            </a>
            <a href="https://linktr.ee/smitkhobragade" target="_blank" rel="noopener noreferrer">
              <FaLink className="w-6 h-6 text-white" />
            </a>
            <a href="https://drive.google.com/file/d/122Pvox8NpAuqOwJ19DeFM09FNPo4mwqD/view?usp=drive_link" target="_blank" rel="noopener noreferrer">
              <IoDocumentAttachOutline className="w-8 h-8 text-white" />
            </a>
          </div>
        </div>

          <button 
            onClick={toggleHelpModal}
            className="bg-blue-600 text-white px-4 py-2 rounded-md"
          >
            <b>?</b>
          </button>
        
      </div>

    
      <HelpModalMobile isVisible={isHelpModalVisible} onClose={toggleHelpModal} />
    </div>
    </>
  );
};

export default FooterMobile;
